import store from 'store'
import { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { REDUX } from 'constants/'
import { RootReducerState } from 'types/global'
import { AuthenticationReducer } from 'types/autentication'
import { CONFIG_GLOBAL } from 'constants/config.global'
import { applyAuthorizationHeader, getAuthHeader } from 'helper/getAuthHeader'

export const getAuthenticationReducers = (state: RootReducerState):AuthenticationReducer => state.authenticationReducers

const isCypressAuthenticated = (): boolean => {
  try {
    return sessionStorage.getItem('test.cypress.authenticated') === 'true'
  } catch {
    return false
  }
}

/** Indício de sessão: JWT válido OU dataAzure no Redux OU bypass Cypress. */
export const hasSessionIndication = (): boolean => {
  if (getAuthHeader() !== null) {
    return true
  }
  if (isCypressAuthenticated()) {
    return true
  }
  try {
    return Boolean(store.getState()?.authenticationReducers?.dataAzure)
  } catch {
    return false
  }
}
/**
 * Callback de ações executado depois do response
 * @param response 
 */
export const onFullfilledResponseServiceNow = (response: AxiosResponse):AxiosResponse => {
  store.dispatch({
    type: REDUX.reducers.HIDE_LOADING,
    payload: null
  })

  return response
}

export const onFullfilledRequestServiceNow = (config: InternalAxiosRequestConfig):InternalAxiosRequestConfig => {
  
  store.dispatch({
    type: REDUX.reducers.SHOW_LOADING,
    payload: null
  })

  applyAuthorizationHeader(config.headers)

  return config
}
/**
 * Callback de ações executado antes de cada request
 * @param response 
 */
export const onFullfilledRequestGraphApi = (config: InternalAxiosRequestConfig):InternalAxiosRequestConfig => {
  store.dispatch({
    type: REDUX.reducers.SHOW_LOADING,
    payload: null
  })
  return config
}
/**
 * Callback de ações executado depois do response
 * @param response 
 */
export const onFullfilledResponseGraphApi = (response: AxiosResponse):AxiosResponse => {
  store.dispatch({
    type: REDUX.reducers.HIDE_LOADING,
    payload: null
  })
  return response
}
/**
 * Callback de ações executadas depois de ocorrer um error
 * @param error
 */
export const onRejectedGraphApi = (error: AxiosError) => {
  store.dispatch({
    type: REDUX.reducers.HIDE_LOADING,
    payload: error
  })
  
  Promise.reject(error)
}

/**
 * Callback de ações executadas depois de ocorrer um error
 * @param error
 */
export const onRejectedServiceNow = (error: any) => {
  store.dispatch({
    type: REDUX.reducers.HIDE_LOADING,
    payload: error
  })

  const isAuthFailure =
    error.status === 401 ||
    [
      CONFIG_GLOBAL.REACT_APP_MESSAGE_EXPIRED_AZURE_TOKEN,
      CONFIG_GLOBAL.REACT_APP_MESSAGE_EXPIRED_TIMESTAMP_TOKEN,
      CONFIG_GLOBAL.REACT_APP_MESSAGE_REQUEST_401
    ].includes(error?.response?.data?.message)

  if (isAuthFailure && hasSessionIndication()) {
    store.dispatch({
      type: REDUX.reducers.SET_AZURE_TOKEN_ACCESS_TOKEN_EXPIRED,
      payload: true
    })
  }
}

export const interceptorApi = {
    addInterceptorsServiceNowApi: (api: AxiosInstance): AxiosInstance =>
      interceptorApi.addInterceptorRequestServiceNow(interceptorApi.addInterceptorResponseServiceNow(api), 'application/json'),
    /**
     * Realiza adição das funcionalisdades de interpctors para request e response do axios 
     * apenas no endpoint da Microsoft Graph
     * @author Qualidor
     * @param api - AxiosInstance
     */
    addInterceptorsGraphApi: (api: AxiosInstance): AxiosInstance =>
      interceptorApi.addInterceptorRequestGraphApi(interceptorApi.addInterceptorResponseGraphApi(api), 'application/json'),
      /**
     * Interceptor request é usado antes de cada requisição para enviar o Token Bearer
     * @author Qualidor
     * @param api - AxiosInstance
     */
    addInterceptorRequestGraphApi: (api: AxiosInstance, contentType: string, token?:string):AxiosInstance => {
      api.interceptors && api.interceptors.request.use(onFullfilledRequestGraphApi, onRejectedGraphApi)
      return api
    },

    addInterceptorRequestServiceNow: (api: AxiosInstance, contentType: string, token?:string):AxiosInstance => {
      api.interceptors && api.interceptors.request.use(onFullfilledRequestServiceNow, onRejectedServiceNow)
      return api
    },
    /**
     * Interceptor response é usado antes de cada resposta para capturar status de resposta e redirecionar para Login
     * @author Qualidor
     * @param api - AxiosInstance
     */
    addInterceptorResponseGraphApi: (api: AxiosInstance): AxiosInstance => {
      api.interceptors && api.interceptors.response.use(onFullfilledResponseGraphApi, onRejectedGraphApi)
      return api
    },

    addInterceptorResponseServiceNow: (api: AxiosInstance): AxiosInstance => {
      api.interceptors && api.interceptors.response.use(onFullfilledResponseServiceNow, onRejectedServiceNow)
      return api
    },
    
  }